import { useState } from 'react';

export default function SubscribeCta() {
  const [done, setDone] = useState(false);

  return (
    <section id="subscribe" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20smooth%20gradient%20of%20deep%20crimson%20and%20warm%20amber%20waves%20on%20minimal%20background%2C%20elegant%20modern%20poster%20texture%2C%20no%20text%2C%20no%20people&width=1600&height=900&seq=cta-18bl-01&orientation=landscape"
          alt="18爆料网订阅与 App 下载入口背景"
          title="18爆料网 · 订阅与下载入口"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-primary-950/90 via-primary-900/85 to-secondary-950/90" />
      </div>

      <div className="relative z-10 mx-auto max-w-[1360px] px-4 md:px-6 lg:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2.5">
              <span className="w-6 h-px bg-accent-400" />
              <span className="text-xs tracking-[0.24em] text-accent-400 font-medium">STAY TUNED</span>
            </div>
            <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl text-background-50 leading-[1.15]">
              别等热搜凉了才来看真相
            </h2>
            <p className="mt-5 text-sm md:text-lg text-background-200 leading-relaxed max-w-2xl">
              订阅 18爆料网，事件有进展第一时间推送。实锤证据、时间线更新、深扒新篇，
              统统一条通知讲清楚。
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3 max-w-xl">
              <button
                type="button"
                className="flex-1 inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-accent-500 text-foreground-950 text-sm md:text-base font-bold hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-fill text-xl" />
                </span>
                App Store 下载
              </button>
              <button
                type="button"
                className="flex-1 inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-background-50/10 text-background-50 text-sm md:text-base font-medium border border-background-50/30 backdrop-blur hover:bg-background-50/20 transition-colors whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-fill text-xl" />
                </span>
                安卓版下载
              </button>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="rounded-lg bg-background-50 p-6 md:p-7">
              <h3 className="font-heading font-bold text-xl text-foreground-950">邮件订阅爆料速报</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                每天一封，只推当天最值得看的三条，含实锤进展与时间线更新。
              </p>

              <div className="mt-5 flex flex-col sm:flex-row gap-3">
                <div className="flex-1 flex items-center gap-2 h-12 px-3.5 rounded-md border border-background-300 bg-background-50 focus-within:border-primary-400">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-foreground-400 text-sm" />
                  </span>
                  <input
                    type="email"
                    placeholder="你的邮箱"
                    aria-label="订阅邮箱"
                    className="flex-1 min-w-0 bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
                  />
                </div>
                <button
                  type="button"
                  onClick={() => setDone(true)}
                  className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  {done ? '已订阅' : '立即订阅'}
                </button>
              </div>

              {done ? (
                <p className="mt-3 flex items-center gap-1.5 text-xs text-primary-600">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-sm" />
                  </span>
                  已收到订阅意向（演示状态，不会真实发送）
                </p>
              ) : (
                <p className="mt-3 text-xs text-foreground-400">
                  订阅即表示你同意接收爆料更新通知。演示状态，不产生真实提交。
                </p>
              )}

              <div className="mt-6 pt-5 border-t border-background-200 flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-shield-check-line text-[13px]" />
                  </span>
                  信源脱敏处理
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-notification-3-line text-[13px]" />
                  </span>
                  仅推送重要进展
                </span>
                <span className="flex items-center gap-1.5">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-close-circle-line text-[13px]" />
                  </span>
                  随时可退订
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}